import { ExtensionTrustSettingsService } from './service/extension-trust-settings.service';
import { Injectable } from '@angular/core';
import { CustomMessageListener } from '@openmfp/portal-ui-lib';

@Injectable({
  providedIn: 'root',
})
export class TrustDataUpdateListener implements CustomMessageListener {
  constructor(private trustService: ExtensionTrustSettingsService) {}

  messageId(): string {
    return 'extension-trust.request-update';
  }

  onCustomMessageReceived(): void {
    this.trustService.sendUpdateToClient();
  }
}
